<div class="card">
  <div class="card-body">
    <div class="order-header">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3 pt-2">
        <button class="btn-link-back" (click)="goBack()">
          <i class="mdi mdi-arrow-left"></i>
          <span>{{ "Quay về danh sách" | translate }}</span>
        </button>
      </div>
    </div>

    <div class="info-card">
      <div class="info-card-header info-card-header--bar">
        <i class="mdi mdi-file-document-outline"></i>
        <span>{{ "Thông tin đơn gia hạn" | translate }}</span>
      </div>
      <div class="detail-list detail-list--row">
        <div class="detail-list-item">
          <i class="mdi mdi-store-outline"></i>
          <div>
            <span class="info-label">{{ "Cửa hàng: " | translate }}</span>
            <span class="info-value">{{ data.workspace_name || "--" }}</span>
          </div>
        </div>
        <div class="detail-list-item" *ngIf="data.mb_reference_number">
          <i class="mdi mdi-swap-horizontal"></i>
          <div>
            <span class="info-label">{{ "Mã giao dịch: " | translate }}</span>
            <span class="info-value">{{ data.mb_reference_number }}</span>
          </div>
        </div>
        <div class="detail-list-item">
          <i class="mdi mdi-account-outline"></i>
          <div>
            <span class="info-label">{{ "Thông tin khách hàng: " | translate }}</span>
            <span class="info-value">{{ data.phone }} - {{ data.full_name }}</span>
          </div>
        </div>
        <div class="detail-list-item">
          <i class="mdi mdi-bank-outline"></i>
          <div>
            <span class="info-label">{{ "Thông tin tài khoản: " | translate }}</span>
            <span class="info-value">
              {{ data.terminal_bank_acc || "Chưa có" }}
              <ng-container *ngIf="data.terminal_bank_acc_name">
                - {{ data.terminal_bank_acc_name }}
              </ng-container>
            </span>
          </div>
        </div>
      </div>
      <div class="detail-list detail-list--row mt-3">
        <div class="detail-list-item">
          <i class="mdi mdi-autorenew"></i>
          <div>
            <span class="info-label">{{ "Loại gia hạn: " | translate }}</span>
            <span class="badge" [ngClass]="data.renew_type === 'AutoDebit' ? 'badge-success' : 'badge-secondary'">
              {{ data.renew_type === 'AutoDebit' ? 'Tự động' : 'Thủ công' }}
            </span>
          </div>
        </div>
        <div class="detail-list-item">
          <i class="mdi mdi-calendar-range"></i>
          <div>
            <span class="info-label">{{ "Gói gia hạn: " | translate }}</span>
            <span class="info-value">{{ data.original_duration }} {{ "tháng" | translate }}</span>
          </div>
        </div>
        <div class="detail-list-item">
          <i class="mdi mdi-currency-usd"></i>
          <div>
            <span class="info-label">{{ "Số tiền: " | translate }}</span>
            <span class="info-value">
              <s *ngIf="data.original_price && data.original_price !== data.discounted_price">
                {{ data.original_price | number : "1.0-0" }}đ
              </s>
              {{ data.discounted_price | number : "1.0-0" }}đ
            </span>
          </div>
        </div>
        <div class="detail-list-item">
          <i class="mdi mdi-calendar-arrow-right"></i>
          <div>
            <span class="info-label">{{ "Ngày gia hạn: " | translate }}</span>
            <span class="info-value">{{ data.created_at | date : "dd/MM/yyyy HH:mm" }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="info-card">
      <div class="info-card-header info-card-header--bar">
        <i class="mdi mdi-flag-outline"></i>
        <span>{{ "Thông tin hoàn phí" | translate }}</span>
      </div>

      <ng-container *ngIf="claim; else noClaim">
        <div class="claim-section">
          <div class="claim-refund-title d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span>{{ "Thông tin claim" | translate }}</span>
            <button
              type="button"
              class="btn btn-sm btn-outline-warning"
              *ngIf="canCreateRefundRequest && (role == 'admin' || role == 'customer service')"
              (click)="openRefundRequestModal(contentRefundRequest)"
            >
              <i class="mdi mdi-cash-refund"></i> {{ "Tạo yêu cầu hoàn phí" | translate }}
            </button>
          </div>
          <div class="claim-reason-box">
            <span class="info-label">{{ "Lý do claim" | translate }}</span>
            <p class="claim-reason-text">{{ claim.claim_reason || "--" }}</p>
          </div>
          <div class="detail-list detail-list--row">
            <div class="detail-list-item">
              <i class="mdi mdi-calendar-alert"></i>
              <div>
                <span class="info-label">{{ "Ngày claim: " | translate }}</span>
                <span class="info-value">{{ claim.claim_date | date : "dd/MM/yyyy" }}</span>
              </div>
            </div>
            <div class="detail-list-item">
              <i class="mdi mdi-account-outline"></i>
              <div>
                <span class="info-label">{{ "Người tạo: " | translate }}</span>
                <span class="info-value">{{ claim.created_by_full_name || "--" }}</span>
              </div>
            </div>
            <div class="detail-list-item">
              <i class="mdi mdi-calendar-clock"></i>
              <div>
                <span class="info-label">{{ "Ngày tạo: " | translate }}</span>
                <span class="info-value">{{ claim.created_at | date : "dd/MM/yyyy HH:mm" }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="claim-section claim-refund-box" *ngIf="claim.order_cancel_id">
          <div class="claim-refund-title d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span>{{ "Yêu cầu hoàn phí" | translate }}</span>
            <button
              type="button"
              class="btn btn-sm btn-outline-success"
              *ngIf="canConfirmRefund && (role == 'admin' || role == 'operation')"
              (click)="openConfirmRefundModal(contentConfirmRefund)"
            >
              <i class="mdi mdi-check-circle-outline"></i> {{ "Xác nhận đã hoàn phí" | translate }}
            </button>
          </div>
          <div class="claim-reason-box" *ngIf="claim.refund_request_reason">
            <span class="info-label">{{ "Lý do" | translate }}</span>
            <p class="claim-reason-text">{{ claim.refund_request_reason }}</p>
          </div>
          <div class="detail-list detail-list--row">
            <div class="detail-list-item">
              <i class="mdi mdi-information-outline"></i>
              <div>
                <span class="info-label">{{ "Trạng thái: " | translate }}</span>
                <span class="info-value">{{ claim.refund_request_status || "--" }}</span>
              </div>
            </div>
            <div class="detail-list-item" *ngIf="claim.refund_transaction_id">
              <i class="mdi mdi-currency-usd"></i>
              <div>
                <span class="info-label">{{ "Số tiền hoàn: " | translate }}</span>
                <span class="info-value">{{ claim.refund_amount | number : "1.0-0" }}đ</span>
              </div>
            </div>
            <div class="detail-list-item" *ngIf="claim.refund_transaction_id">
              <i class="mdi mdi-pound"></i>
              <div>
                <span class="info-label">{{ "Mã giao dịch: " | translate }}</span>
                <span class="info-value">{{ claim.refund_ft_code }}</span>
              </div>
            </div>
            <div class="detail-list-item" *ngIf="claim.refund_transaction_id">
              <i class="mdi mdi-calendar-check-outline"></i>
              <div>
                <span class="info-label">{{ "Ngày hoàn: " | translate }}</span>
                <span class="info-value">{{ formatRefundDate(claim.refund_date) }}</span>
              </div>
            </div>
          </div>
          <div class="claim-reason-box" *ngIf="claim.refund_transaction_id && claim.refund_reason">
            <span class="info-label">{{ "Nội dung hoàn phí" | translate }}</span>
            <p class="claim-reason-text">{{ claim.refund_reason }}</p>
          </div>
        </div>
      </ng-container>
      <ng-template #noClaim>
        <div class="text-center text-muted py-3">{{ "Chưa có claim nào cho đơn gia hạn này" | translate }}</div>
      </ng-template>
    </div>

    <div class="detail-row">
      <div class="info-card">
        <div class="info-card-header info-card-header--bar">
          <i class="mdi mdi-file-certificate-outline"></i>
          <span>{{ "Hoá đơn gốc" | translate }}</span>
        </div>
        <div class="detail-list">
          <div class="detail-list-item">
            <i class="mdi mdi-pound"></i>
            <div>
              <span class="info-label">{{ "Số hoá đơn" | translate }}</span>
              <span class="info-value">{{ data.invoice_no || "--" }}</span>
            </div>
          </div>
          <div class="detail-list-item">
            <i class="mdi mdi-calendar-check-outline"></i>
            <div>
              <span class="info-label">{{ "Ngày xuất" | translate }}</span>
              <span class="info-value">{{ data.invoice_date ? (data.invoice_date | date : "dd/MM/yyyy HH:mm") : "--" }}</span>
            </div>
          </div>
          <div class="detail-list-item">
            <i class="mdi mdi-information-outline"></i>
            <div>
              <span class="info-label">{{ "Trạng thái" | translate }}</span>
              <span class="info-value">{{ data.invoice_status || "--" }}</span>
            </div>
          </div>
          <div class="detail-list-item" *ngIf="data.invoice_err_message">
            <i class="mdi mdi-alert-circle-outline text-danger"></i>
            <div>
              <span class="info-label">{{ "Lỗi" | translate }}</span>
              <span class="info-value text-danger">{{ data.invoice_err_message }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="info-card">
        <div class="info-card-header info-card-header--bar">
          <i class="mdi mdi-file-replace-outline"></i>
          <span>{{ "Hoá đơn thay thế" | translate }}</span>
        </div>
        <div class="detail-list">
          <div class="detail-list-item">
            <i class="mdi mdi-pound"></i>
            <div>
              <span class="info-label">{{ "Số hoá đơn" | translate }}</span>
              <span class="info-value">{{ data.replace_invoice_no || "--" }}</span>
            </div>
          </div>
          <div class="detail-list-item">
            <i class="mdi mdi-calendar-check-outline"></i>
            <div>
              <span class="info-label">{{ "Ngày xuất" | translate }}</span>
              <span class="info-value">{{ data.replace_invoice_date ? (data.replace_invoice_date | date : "dd/MM/yyyy HH:mm") : "--" }}</span>
            </div>
          </div>
          <div class="detail-list-item">
            <i class="mdi mdi-information-outline"></i>
            <div>
              <span class="info-label">{{ "Trạng thái" | translate }}</span>
              <span class="info-value">{{ data.replace_invoice_status || "--" }}</span>
            </div>
          </div>
          <div class="detail-list-item" *ngIf="data.replace_invoice_err_message">
            <i class="mdi mdi-alert-circle-outline text-danger"></i>
            <div>
              <span class="info-label">{{ "Lỗi" | translate }}</span>
              <span class="info-value text-danger">{{ data.replace_invoice_err_message }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-card">
      <div class="info-card-header info-card-header--bar">
        <i class="mdi mdi-history"></i>
        <span>{{ "Lịch sử thao tác" | translate }}</span>
      </div>
      <div class="log-timeline-header" *ngIf="listDataLog?.length">
        <span class="log-timeline-header-spacer"></span>
        <div class="log-timeline-header-cols">
          <span>{{ "Thao tác" | translate }}</span>
          <span>{{ "Ghi chú" | translate }}</span>
          <span>{{ "Thời gian" | translate }}</span>
        </div>
      </div>
      <div class="log-timeline">
        <div
          class="log-timeline-item"
          *ngFor="let log of listDataLog; let last = last"
          [class.is-last]="last"
        >
          <div class="log-timeline-dot">
            <i class="mdi mdi-swap-horizontal"></i>
          </div>
          <div class="log-timeline-content">
            <div class="log-timeline-main">
              <p class="log-action">{{ log.action }}</p>
              <p class="log-actor">{{ log.full_name }}</p>
            </div>
            <div class="log-note-col">
              <span class="log-note" *ngIf="log.reason || log.note">{{ log.reason || log.note }}</span>
              <span class="log-note-empty" *ngIf="!log.reason && !log.note">--</span>
            </div>
            <div class="log-time" *ngIf="formatLogDateTime(log.datetime) as t">
              <span class="log-date">{{ t.date }}</span>
              <span class="log-clock">{{ t.time }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="!listDataLog || listDataLog.length === 0" class="text-center text-muted py-3">
          {{ "Chưa có dữ liệu" | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #contentRefundRequest role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ "Tạo yêu cầu hoàn phí gia hạn" | translate }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formRefundRequest" (ngSubmit)="submitRefundRequest()">
        <div class="form-group row col-md-12">
          <label class="col-md-12 col-form-label required_label">
            {{ "Lý do hoàn phí" | translate }}
          </label>
          <div class="col-md-12">
            <textarea
              formControlName="reason"
              class="form-control"
              rows="4"
              [ngClass]="{ 'is-invalid': submittedRefundRequest && formRefundRequest.get('reason').errors }"
              placeholder="{{ 'Nhập lý do hoàn phí' | translate }}"
            ></textarea>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button type="submit" class="btn btn-success btn-lg" style="width: 150px">
            {{ "Xác nhận" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentConfirmRefund role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ "Xác nhận đã hoàn phí" | translate }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formConfirmRefund" (ngSubmit)="submitConfirmRefund()">
        <div class="form-group row col-md-12">
          <label class="col-md-12 col-form-label required_label">
            {{ "Nhập thông tin giao dịch hoàn" | translate }}
          </label>
          <div class="col-md-12">
            <textarea
              formControlName="reason"
              class="form-control"
              rows="4"
              [ngClass]="{ 'is-invalid': submittedConfirmRefund && formConfirmRefund.get('reason').errors }"
            ></textarea>
          </div>
        </div>

        <div class="form-group row col-md-12">
          <label class="col-md-12 col-form-label required_label">{{ "Số tiền hoàn" | translate }}</label>
          <div class="col-md-12">
            <input
              type="text"
              [value]="refundAmountDisplay"
              class="form-control"
              [ngClass]="{ 'is-invalid': submittedConfirmRefund && formConfirmRefund.get('amount').invalid }"
              (input)="onAmountInput($event)"
              inputmode="numeric"
              placeholder="{{ 'Nhập số tiền' | translate }}"
            />
            <small class="form-text text-muted">
              {{ "Số tiền hoàn phải lớn hơn 0 và không vượt quá" | translate }}
              {{ data?.discounted_price | number : "1.0-0" }}đ
            </small>
            <div class="invalid-feedback"
                 *ngIf="submittedConfirmRefund && formConfirmRefund.get('amount').hasError('max')">
              {{ "Số tiền hoàn không được vượt quá số tiền của đơn gia hạn" | translate }}
            </div>
            <div class="invalid-feedback"
                 *ngIf="submittedConfirmRefund && formConfirmRefund.get('amount').hasError('min')">
              {{ "Số tiền hoàn phải lớn hơn 0" | translate }}
            </div>
          </div>
        </div>

        <div class="form-group row col-md-12">
          <label class="col-md-12 col-form-label required_label">{{ "Mã giao dịch" | translate }}</label>
          <div class="col-md-12">
            <input
              type="text"
              formControlName="ftCode"
              class="form-control"
              [ngClass]="{ 'is-invalid': submittedConfirmRefund && formConfirmRefund.get('ftCode').invalid }"
              placeholder="{{ 'Nhập mã giao dịch' | translate }}"
            />
          </div>
        </div>

        <div class="form-group row col-md-12">
          <label class="col-md-12 col-form-label required_label">{{ "Ngày giao dịch" | translate }}</label>
          <div class="col-md-12">
            <mat-form-field appearance="fill" class="w-100 mt-2">
              <mat-label>{{ "Chọn ngày giao dịch" | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="pickerConfirmRefund"
                formControlName="refundDate"
                placeholder="{{ 'Ngày giao dịch' | translate }}"
              />
              <mat-datepicker-toggle matSuffix [for]="pickerConfirmRefund"></mat-datepicker-toggle>
              <mat-datepicker #pickerConfirmRefund></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            [disabled]="
              !formConfirmRefund.get('reason')?.value?.trim() ||
              formConfirmRefund.get('amount')?.invalid ||
              !formConfirmRefund.get('ftCode')?.value?.trim() ||
              !formConfirmRefund.get('refundDate')?.value
            "
            type="submit"
            class="btn btn-danger btn-lg"
            style="width: 150px"
          >
            {{ "Xác nhận" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
